<template>
  <div class="d-flex">
    <clear-icon v-if="type === 'error'" class="toastify-icon toastify-icon--error"/>
    <div>
      <div :class="['toastify-title', titleClass]" v-if="title">{{ title }}</div>
      <ul class="toastify-message-list" v-if="messages.length">
        <li :class="['toastify-message', messageClass]" v-for="message in messages">{{ message }}</li>
      </ul>
    </div>
  </div>
</template>
<script setup>
  import { computed } from 'vue';
  import ClearIcon from '@/components/icons/clear.vue';

  const props = defineProps({
    title: {
      type: String,
      required: false,
      default: null,
    },
    text: {
      type: String,
      required: false,
      default: null,
    },
    messages: {
      type: Array,
      required: false,
      default: () => [],
    },
    type: {
      type: String,
      required: false,
      default: 'error',
    },
  });

  const titleClass = computed(() => `toastify-title--${props.type}`);
  const messageClass = computed(() => `toastify-message--${props.type}`);
</script>
